export default __webpack_public_path__ + "static/media/rezultati.b627e6dd.pdf";